import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando o componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Textarea from '~/components/Form/Textarea';
import Load from '~/components/Load';

import { Container } from './styles';

export default function ProductNew() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [incorporadoras, setIncorporadoras] = useState([]);
  const [whatsapp, setWhatsapp] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [cadencias, setCadencias] = useState([]);
  const [integracoes, setIntegracoes] = useState([]);
  const [times, setTimes] = useState([]);
  const [visibleCrm, setVisibleCrm] = useState(false);
  const user = useSelector(state => state.user.profile);

  const getTimes = useCallback(async () => {
    setLoading(true);
    const response = await api.get('/times-select');
    const data = response.data.map(inc => ({
      value: inc.id,
      label: inc.name,
    }));
    setTimes(data);
    setLoading(false);
  }, []);

  const getWhatsappIntegracao = useCallback(async () => {
    const responseWhatsapp = await api.get('/whatsapp');

    const dataWhatsapp = responseWhatsapp.data.map(what => {
      return {
        value: what.id,
        label: what.name,
      };
    });

    setWhatsapp(dataWhatsapp);
  }, []);

  useEffect(() => {
    getTimes();
    getWhatsappIntegracao();
  }, [getTimes, getWhatsappIntegracao]);

  useEffect(() => {
    async function getCidades() {
      // Buscando as cidades
      setLoading(true);
      const response = await api.get('/cidades');
      const data = response.data.map(cidade => ({
        value: cidade.id,
        label: cidade.name,
      }));

      // Verificando se é usuario bamboo e buscando incorporadoras
      if (user.provider === '4') {
        const res = await api.get('/incorporadora');
        const datas = res.data.map(inc => ({
          value: inc.id,
          label: inc.name,
        }));

        setIncorporadoras(datas);
      }

      // Buscando as cadencias
      const cad = await api.get('/cadencia');
      const dataCad = cad.data.map(ca => ({
        value: ca.id,
        label: ca.name,
      }));

      // Buscando as integrações
      const responseInte = await api.get('/integracao');
      const dataInte = responseInte.data.map(int => ({
        value: int.id,
        label: int.name,
      }));

      setIntegracoes(dataInte);
      setCadencias(dataCad);
      setCidades(data);
      setLoading(false);
    }
    getCidades();
  }, [user.provider]);

  /**
   * Funçoes
   */

  async function handleSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});

      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          cadencia_id: Yup.string('Selecione uma cadencia').required(
            'Selecione uma cadencia'
          ),
          integracao_id: Yup.string('Selecione uma integração').required(
            'Selecione uma integração'
          ),
          incorporadora_id: Yup.string('Selecione uma incorporadora').required(
            'Selecione uma incorporadora'
          ),
          time_id: Yup.string('Selecione um time').required(
            'Selecione um time'
          ),
          whatsapp_id: Yup.string(
            'Selecione uma integração de mensagem no whatsapp'
          ).required('Selecione uma integração de mensagem no whatsapp'),
          name: Yup.string().required('Preencha o campo nome'),
          description: Yup.string().required('Preencha o campo descrição'),
          chamada: Yup.string().required('Preencha o campo chamada'),
          crm_id: visibleCrm
            ? Yup.string().required('Preencha o campo Id do crm do produto')
            : null,
        });
      } else {
        schema = Yup.object().shape({
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          cadencia_id: Yup.string('Selecione uma cadencia').required(
            'Selecione uma cadencia'
          ),
          integracao_id: Yup.string('Selecione uma integração').required(
            'Selecione uma integração'
          ),
          time_id: Yup.string('Selecione um time').required(
            'Selecione um time'
          ),
          whatsapp_id: Yup.string(
            'Selecione uma integração de mensagem no whatsapp'
          ).required('Selecione uma integração de mensagem no whatsapp'),
          name: Yup.string().required('Preencha o campo nome'),
          description: Yup.string().required('Preencha o campo descrição'),
          chamada: Yup.string().required('Preencha o campo chamada'),
          crm_id: visibleCrm
            ? Yup.string().required('Preencha o campo Id do crm do produto')
            : null,
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const incorporadora =
        user.provider === '4'
          ? data.incorporadora_id
          : user.time.incorporadora_id;

      await api.post('/produtos', {
        cidade_id: data.cidade_id,
        cadencia_id: data.cadencia_id,
        integracao_id: data.integracao_id,
        incorporadora_id: incorporadora,
        time_id: data.time_id,
        whatsapp_id: data.whatsapp_id,
        name: data.name,
        description: data.description,
        chamada: data.chamada,
        crm_id: visibleCrm ? data.crm_id : null,
      });

      toast.success('Produto criado com sucesso');
      history.push('/produto');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao criar produto, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleIntegracao(e) {
    if (e.label !== 'RealizaApp') {
      setVisibleCrm(true);
    } else {
      setVisibleCrm(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Cadastrar Produto</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handleSubmit} autoComplete="off">
          <Select name="cidade_id" labelSelect="Cidade" options={cidades} />
          {user.provider === '4' && (
            <Select
              name="incorporadora_id"
              labelSelect="Incorporadora"
              options={incorporadoras}
            />
          )}
          <Select name="time_id" labelSelect="Time" options={times} />
          <Select
            name="cadencia_id"
            labelSelect="Cadencia"
            options={cadencias}
          />
          <Select
            name="integracao_id"
            labelSelect="Integração"
            options={integracoes}
            onChange={e => handleIntegracao(e)}
          />
          <Select
            name="whatsapp_id"
            labelSelect="Integração de mensagens do whatsapp"
            options={whatsapp}
          />
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input
            icon="MdFeaturedVideo"
            label="Chamada do produto"
            name="chamada"
            type="text"
          />
          {visibleCrm && (
            <Input
              icon="MdAccountBalanceWallet"
              label="Id do produto no crm"
              name="crm_id"
              type="number"
            />
          )}
          <Textarea label="Descrição" name="description" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
